module.exports = __webpack_public_path__ + "media/images/river/just-fits-f2e4fb9edc94915aff57f99421890883.png";